export enum IFrameMessage {
  SUBSCRIPTION_CREATED = 'SUBSCRIPTION_CREATED',
  SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR',
  TRIGGER_GO_BACK = 'TRIGGER_GO_BACK',
  SCROLL_TO_TOP = 'SCROLL_TO_TOP',
}
